<template>
    <div class="data-wrapper-core email-templates-wrapper">
        <template v-if="!hideHeader">
            <h3>Email Templates</h3>
            <v-divider></v-divider>
        </template>
        <v-text-field class="email-templates-search-field" prepend-inner-icon="mdi-magnify" variant="outlined" density="compact"
            label="Suche" hide-details single-line rounded="lg" v-model="searchQuery"></v-text-field>
        <v-expansion-panels class="subuser-panels">
            <v-expansion-panel rounded="lg" v-for="emailTemplate in emailTemplates" :key="emailTemplate._id">
                <v-expansion-panel-title class="email-templates-panel-title">
                    <h4>{{ emailTemplate.name }}</h4>
                </v-expansion-panel-title>
                <v-expansion-panel-text class="email-templates-panel-text">
                    <v-list density="compact">
                        <h4>Subject:</h4>
                        <v-list-item>{{ emailTemplate.subject || "--" }}</v-list-item>
                        <h4>Erstellt am:</h4>
                        <v-list-item>{{ emailTemplate.createdAt || "--" }}</v-list-item>
                        <h4>htmlText:</h4>
                        <v-list-item>{{ emailTemplate.htmlText || "--" }}</v-list-item>
                        <h4>__v:</h4>
                        <v-list-item>{{ emailTemplate.__v }}</v-list-item>
                        <h4>_id:</h4>
                        <v-list-item>{{ emailTemplate._id }}</v-list-item>
                    </v-list>
                </v-expansion-panel-text>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        hideHeader: { type: Boolean, default: false }
    },
    data() {
        return {
            searchQuery: '',
        };
    },
    computed: {
        ...mapState('agency', ['emailTemplates']),
        filteredEmailTemplates() {
            if (!this.searchQuery) {
                return this.emailTemplates;
            }
            return this.emailTemplates.filter(emailTemplates => emailTemplates.name.toLowerCase().includes(this.searchQuery.toLowerCase()));
        },
    },
}
</script>

<style lang="scss" scoped>

.email-templates-wrapper {
    max-height: 600px;
    overflow-y: auto;
}

.email-templates-search-field {
    margin: 8px 0;
}

.email-templates-panels {
    margin: 8px 0;
}

.email-templates-panel-text {
    padding: 0px 16px;
}

</style>